import ApiClient from '@/api/ApiClient';
import { ARMADO_URL } from '@/utils/CONST';

const client = new ApiClient('client/bill');

class BillApiClient {

	static grid (filter: IBillPagedListForClientParameters) {
		return client.post<IPagedList<IBillItemForClientModel>>('grid', filter);
	}

	static getDetailed (id: number) {
		return client.get<IBillOverPageForClientModel>(id.toString());
	}

	static saveNote (id: number, note: string) {
		return client.put<void>(`${id}/note`, note?.toPost());
	}

	static getNotViewed () {
		return client.get<number>('countNew');
	}

	static download (idsQuery: string) {
		client.windowOpen(`${ARMADO_URL}/app/client/bill${idsQuery}&isDownload=true`, '_blank');
	}

	static view (idsQuery: string) {
		client.windowOpen(`${ARMADO_URL}/app/client/bill${idsQuery}`, '_blank');
	}

}

export default BillApiClient;
